import React, { useState, useEffect } from 'react'
import { StyledTitle, StyledAlredyHaveAccountText, StyledBottomDiv, StyledWrapper, StyledReferTitle } from './styles'
import { useTranslation } from '../../../../../context/translationProvider'
import GoogleSignIn from '../../../../molecules/GoogleSignIn'
import { Link } from 'gatsby'
import useSlugs from '../../../../../hooks/useSlugs'
import { useModalContext } from '../../../../../context/modalProvider'
import { toast } from '../../../../atoms'
import { treatLoginErrors } from '../../../../../utils/treatLogginErrors'
import { Button } from '../../../../atoms/button'
import { Divider } from '../../../../atoms/divider'
import { useEventTracking } from '../../../../../context/eventTrackingProvider'
import { If } from '../../../../atoms/if'
import { Login2faSSOContent } from '../../../login2faSSOContent'
import ReferIcon from './../../../../../images/icon_refer_a_friend.svg';
import { Image } from './../../../../atoms/image'
import { Text } from '../../../../atoms/text'
import { ResponsibleGamblingWarning } from '../../../../atoms/ResponsibleGamblingWarning'

export const RegisterLobby = ({ onCompleteStep, onSocialAuthSuccess, isPage }) => {
  const { translate } = useTranslation()
  const { trackEvent, EVENT_NAMES } = useEventTracking()

  const [loginSlug] = useSlugs(['login'])
  const { close } = useModalContext()
  const [referAFriendRegister, setReferAFriendRegister] = useState(false)

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search)
    const hasReferrerCode = urlParams.has('referrerCode')
    setReferAFriendRegister(hasReferrerCode)
  }, [])

  const [ssoData, setSSOData] = useState()
  const [is2faVerificationPending, setIs2faVerificationPending] = useState(false)

  const onLogin = () => {
    if (location.pathname.includes(`/${loginSlug}/`)) close()
  }

  const treatCommonErrors = (response) => {
    if (response.error?.messageCode === 740) {
      setSSOData(response.error.data)
      setIs2faVerificationPending(true)
      return
    }

    const errorMessage = treatLoginErrors(response.error, translate)

    toast.error(errorMessage)
  }

  const onSelectEmail = () => {
    trackEvent(EVENT_NAMES.REGISTER_WITH_EMAIL, {}, true)
    onCompleteStep([])
  }

  const renderTitle = () => {
    return <If 
      condition={referAFriendRegister}
      render={() => (
        <>
          <StyledReferTitle>
            <StyledTitle>
              <p  
                dangerouslySetInnerHTML={{
                __html: translate('register.lobby.referAFriendTitle').replace(/(\w+)([^\w]*)$/, '<span>$1</span>$2')
                }}
              />
              <Image url={ReferIcon} />
            </StyledTitle>
            <Text>{translate('register.lobby.description')}</Text>
          </StyledReferTitle>
        </>
      )}
      renderElse={() => (
        <StyledTitle>
          {translate('register.lobby.title')}
        </StyledTitle>
      )}
    />
  }

  return (
    <If 
      condition={!is2faVerificationPending}
      render={() => (
        <StyledWrapper isPage={isPage}>
          {renderTitle()}
          <GoogleSignIn 
            onAuthSuccess={onSocialAuthSuccess} 
            onAuthError={treatCommonErrors}
            buttonLabel={translate('register.lobby.googleButton')}
            eventName={EVENT_NAMES.REGISTER_WITH_GOOGLE}
          />
          <Divider />
          <Button
            expand
            dark
            bordered
            bold={false}
            onClick={onSelectEmail}
          >
            {translate('register.lobby.emailButton')}
          </Button>
          <StyledAlredyHaveAccountText>
            {translate('register.alreadyHaveAccount')}{' '}
            <Link to={`/${loginSlug}`} onClick={onLogin}>
              {translate('register.login')}
            </Link>
          </StyledAlredyHaveAccountText>
          <StyledBottomDiv isPage={isPage}>
            <ResponsibleGamblingWarning />
          </StyledBottomDiv>
        </StyledWrapper>
      )}
      renderElse={() => (
        <Login2faSSOContent 
          {...ssoData}
          onFail ={() => {
            setIs2faVerificationPending(false)
            setSSOData(null)
          }} 
          onAuthError={treatCommonErrors}
        />
      )}
    />
  )
}
